module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/instagram/suns_sns_02-eddd2dbea78ab1550cff0f54d243b883.jpg";